class TagsDelegate {
    setSearchText(searchText) {
        this.setState({ searchText });
    }

    setFormModalVisible(formModalVisible) {
        this.setState({ formModalVisible });
    }

    setAssignmentModalVisible(assignmentModalVisible) {
        this.setState({ assignmentModalVisible });
    }

    setSOSModalVisible(sosModalVisible) {
        this.setState({ sosModalVisible });
    }

    setSelectedTag(selectedTag) {
        this.setState({ selectedTag });
    }

    setFilterModelType(filterModelType) {
        this.setState({ filterModelType });
    }

    setFilterHasSOS(filterHasSOS) {
        this.setState({ filterHasSOS });
    }
}

export default TagsDelegate;
